// extracted by mini-css-extract-plugin
export default {"item":"role-permission_item__Au2mW"};